// extracted by mini-css-extract-plugin
export default {"root":"MainView_root__2JhLH"};